import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { FormDataUpload, NestApiProvider } from '../nest-api';
import { IGetDefaultShift } from '../nest-model/shift-schedule-model';
import { responseArray, responseObj } from '../nest-model/nest-model';

@Injectable()
export class ShiftScheduleApiProvider {

  private _service: string = 'attendance';
  private _module: string = 'attendance';
  private _model: string = 'sfshiftschedule';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public companySetting(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'companySetting';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public downloadTemplate(params: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadTemplate';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

  public downloadTemplateUrl(queryParams: any) {
    const method: string = 'GET';
    const func: string = 'downloadTemplate';
    const params: any = {};
    const urlParams: any = queryParams;
    const url = this.nestApiProvider.urlBuilder(method, this._model, func, params, urlParams, null);
    return url;
  }

  public uploadShiftScheduleFile(file: File): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'uploadShiftScheduleFile';
    const _params: FormDataUpload[] = [];
    _params.push({ name: 'file', value: file });
    const _urlParams: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestUpload(_method, _url, _params);
  }

  public getDefaultShift(formData) {
    const method: string = "POST";
    const model: string = "sfshiftschedule";
    const func: string = "getDefaultShift";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this._module);
    return this.nestApiProvider.request<responseArray<IGetDefaultShift>>(method, url, params, urlParams, body, contentType);
  }

  public procsave(formData) {
    const method: string = "POST";
    const model: string = "sfshiftschedule";
    const func: string = "procsave";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this._module);
    return this.nestApiProvider.request(method, url, params, urlParams, body, contentType);
  }

  public shiftUploadFile(file: File): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'shiftUploadFile';
    const _params: FormDataUpload[] = [];
    _params.push({ name: 'file', value: file });
    const _urlParams: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestUpload(_method, _url, _params);
  }

  public shiftProcessUpload(formData) {
    const method: string = "POST";
    const func: string = "shiftProcessUpload";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, this._model, func, params, urlParams, this._module);
    return this.nestApiProvider.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/attendance/shift-schedule-api.ts